import { useWorkspace } from '../../../../../../../contexts/WorkspaceContext'
import Dropdown from '../../../../../../ui/Dropdown/Dropdown'
import DropdownDivider from '@/components/ui/Dropdown/components/DropdownDivider/DropdownDivider'
import DropdownItem from '@/components/ui/Dropdown/components/DropdownItem/DropdownItem'
import type { Notification } from '../../../../../../../store/notifications/notificationsSlice'
import type { WorkspaceMember } from '../../../../../../../contexts/WorkspaceContext'
import type { Task } from '../../../../../../../contexts/TasksContext'
import InboxDropdownItem from '../InboxDropdownItem/InboxDropdownItem'
import InboxDropdownEmpty from '../InboxDropdownEmpty/InboxDropdownEmpty'
import css from './InboxDropdown.module.css'
import { getNotificationTitle } from '@/utils/notificationTitle'
import { PLATE_BOT_NAME, PLATE_BOT_AVATAR } from '@/const/constants'

interface InboxDropdownProps {
    isOpen: boolean
    onClose: () => void
    notifications: Notification[]
    tasksById: Record<string, Task>
    projectsById: Record<string, any>
    tasksLoaded: boolean
    onNotificationClick: (n: Notification) => void
    onAllNotifications: () => void
}

const MAX_ITEMS = 4

const InboxDropdown = ({
    isOpen,
    onClose,
    notifications,
    tasksById,
    projectsById,
    tasksLoaded,
    onNotificationClick,
    onAllNotifications,
}: InboxDropdownProps) => {
    const { getMember, statuses } = useWorkspace()

    const getActionText = (n: Notification) => {
        if (n.type === 'comment') return 'replied'
        if (n.type === 'assignee') return 'assigned to you'
        if (n.type === 'mention') return 'mentioned you'
        if (n.type === 'status') {
            const task = tasksById[n.taskId]
            const status = task ? statuses.find((s: any) => s.id === task.statusId) : null
            return status ? `> ${status.name}` : '> —'
        }
        return n.type
    }

    const unwatched = notifications.filter(n => !n.watched).slice(0, MAX_ITEMS)

    return (
        <Dropdown isOpen={isOpen} onClose={onClose} direction="up" align="left" className={css.dropdown}>
            {unwatched.length === 0 ? (
                <InboxDropdownEmpty />
            ) : (
                unwatched.map((n: Notification) => {
                    const name = getNotificationTitle({
                        notification: n,
                        task: tasksById[n.taskId],
                        project: projectsById[n.projectId],
                        tasksLoaded,
                    })
                    const initiator = getMember(n.createdBy) ?? {
                        username: PLATE_BOT_NAME,
                        color: '#6366f1',
                        avatarImage: PLATE_BOT_AVATAR,
                    } as WorkspaceMember

                    const actionText = getActionText(n)
                    return (
                        <InboxDropdownItem
                            key={n.id}
                            taskName={name}
                            initiator={initiator}
                            actionText={actionText}
                            onClick={() => onNotificationClick(n)}
                        />
                    )
                })
            )}
            <DropdownDivider />
            <DropdownItem title="All notifications" onClick={onAllNotifications} />
        </Dropdown>
    )
}

export default InboxDropdown
